module.exports = __webpack_public_path__ + "img/dynamic-18.7fe387c6.png";